import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import addProduct from "../../utils/addProducts.png";
import deleteIcon from "../../utils/delete.png";
import Tooltip from "@mui/material/Tooltip";
import notAllowedSymbol from "../../utils/notAllowedSymbol.svg";
import axios from "axios";
import "../../css/ProductsInQuotation.css";
import { TextField, Autocomplete } from "@mui/material";

const ProductsInQuotation = ({
  productEntryInAllEntries,
  setProductEntries,
  productEntries,
  handleAddRow,
  handleInputChange,
  selectProduct,
  viewProduct,
  currentProductEntryRowId,
  productData,
  productsInQuotationState,
  deleteSelectedRows,
  markFOCForSelectedRows,
  markSubstituteForSelectedRows,
  setCurrentF2ItemForSearchPopup,
  rowInputRefs,
  selectedRows,
  setSelectedRows,
  qtyInputRefsFromParent,
}) => {
  const [pendingQtyFocus, setPendingQtyFocus] = useState(null);
  const containerRef = useRef(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const listboxRef = useRef(null);

  const qtyInputRefs = useRef({});
  const priceInputRefs = useRef({}); // Add this near your other refs

  let company_code_from_local_storage = localStorage.getItem("companyCode")
    ? localStorage.getItem("companyCode")
    : "-";
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  const imageApiPath = apiPaths_from_local_storage[0]?.IMG_API_PATH;

  const url = window.location.pathname;

  console.log(
    "productsInQuotationState in ProductsInQuotation ",
    productsInQuotationState,
    url
  );

  const [showHideViewLcoationSubstitute, setShowHideViewLcoationSubstitute] =
    useState(false);
  const [currentLocationSearchCode, setCurrentLocationSearchCode] =
    useState(null);
  
  const [locationStockArray, setLocationStockArray] = useState(null);
  const [substituteStockArray, setSubstituteStockArray] = useState(null);

  const [isSelectedItemCodeCorrect, setIsSelectedItemCodeCorrect] =
    useState(false);

  const toggleSelectAll = () => {
    if (selectedRows?.length === productsInQuotationState?.length) {
      setSelectedRows([]); // Unselect all if all are selected
    } else {
      setSelectedRows(productsInQuotationState?.map((_, index) => index)); // Select all rows
    }
  };

  // Toggle selection of a row
  const toggleRowSelection = (index) => {
    setSelectedRows(
      (prevSelectedRows) =>
        prevSelectedRows.includes(index)
          ? prevSelectedRows.filter((i) => i !== index) // Remove if already selected
          : [...prevSelectedRows, index] // Add if not selected
    );
  };

  const productsWithImage = productData?.filter(
    (prod) => prod.Imagepath !== ""
  );
  const imagePaths = productsWithImage?.map((prod) => prod.Imagepath);
  // console.log('productsWithImage',productsWithImage)
  // console.log('imagePaths',imagePaths)

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchItemImage = (itemFilePath) => {
    if (!itemFilePath) return "";

    // If backend ever sends a proper URL
    if (/^https?:\/\//i.test(itemFilePath)) {
      return itemFilePath;
    }

    // Normalize Windows backslashes
    const normalizedPath = itemFilePath.replace(/\\/g, "/");

    // Extract filename after the folder
    const fileName = normalizedPath.split("BONDTIME_PRODUCT_IMG/")[1];

    if (!fileName) {
      console.warn("Invalid image path:", itemFilePath);
      return "";
    }

    return `${imageApiPath}/BONDTIME_PRODUCT_IMG/${fileName}`;
  };

  const getStyleOfChip = () => {
    return "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset";
  };

  const getLocationStock = (itemcode) => {
    setCurrentLocationSearchCode(itemcode);
    let encodedItemCode = encodeURIComponent(itemcode);
    axios
      .get(
        `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/LOCATIONSTOCK/${encodedItemCode}`
      )
      .then((res) => {
        setLocationStockArray(res.data);
      })
      .catch((err) => {});
  };

  const getSubstituteArray = (itemcode) => {
    let encodedItemCode = encodeURIComponent(itemcode);
    axios
      .get(
        `${apiPaths_from_local_storage[0].API_CONFIG}/api/Search_Items/${company_code_from_local_storage}/GETSUBSTITUTES/${encodedItemCode}`
      )
      .then((res) => {
        setSubstituteStockArray(res.data);
      })
      .catch((err) => {});
  };

  // Dealing with Textarea Height
  function calcHeight(e) {
    // let numberOfLineBreaks = (value.match(/\n/g) || []).length;
    // // min-height + lines x line-height + padding + border
    // let newHeight = 45 + numberOfLineBreaks * 20 + 12 + 2;

    console.log("e.target.scrollHeight ", e.target.scrollHeight);

    return e.target.scrollHeight;
  }

  function moveCaretToEnd(el) {
    if (typeof el.selectionStart === "number") {
      el.selectionStart = el.selectionEnd = el.value.length;
    } else if (typeof el.createTextRange != "undefined") {
      el.focus();
      var range = el.createTextRange();
      range.collapse(false);
      range.select();
    }
  }

  useEffect(() => {
    if (highlightedIndex >= 0 && listboxRef.current) {
      const rows = listboxRef.current.querySelectorAll("tbody tr");
      const highlightedRow = rows[highlightedIndex];

      if (highlightedRow) {
        highlightedRow.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }
  }, [highlightedIndex]);

  useEffect(() => {
    if (pendingQtyFocus && qtyInputRefs.current[pendingQtyFocus]) {
      qtyInputRefs.current[pendingQtyFocus].focus();
      qtyInputRefs.current[pendingQtyFocus].select();
      setPendingQtyFocus(null);
    }
  }, [productEntries, pendingQtyFocus]); // fires AFTER re-render

  const TableListboxComponent = React.forwardRef(function ListboxComponent(
    props,
    ref
  ) {
    const { children, ...other } = props;
    return (
      <div
        ref={(node) => {
          listboxRef.current = node;
          if (typeof ref === "function") {
            ref(node);
          } else if (ref) {
            ref.current = node;
          }
        }}
        {...other}
        className="max-h-[400px] overflow-auto"
      >
        <table className="w-full border-collapse table-fixed bg-white">
          <thead className="sticky top-0 bg-gray-100 z-10 shadow-sm">
            <tr className="text-[11px] uppercase text-gray-600 border-b">
              <th className="p-2 text-left w-[20%]">Code</th>
              <th className="p-2 text-left w-[20%]">Description</th>
              <th className="p-2 text-center w-[6%]">Unit</th>
              <th className="p-2 text-center w-[7%]">Category</th>
              <th className="p-2 text-center w-[7%]">Total Stock</th>
              <th className="p-2 text-center w-[7%]">Br Stock</th>

              <th className="p-2 text-center w-[10%]">Group</th>
              <th className="p-2 text-center w-[8%]">Sub Group</th>
              <th className="p-2 text-center w-[15%]">Price</th>
            </tr>
          </thead>
          <tbody className="text-sm">{children}</tbody>
        </table>
      </div>
    );
  });
  return (
    <div className="productsContainer rounded py-4  min-h-[300px]">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-thin">Products Of Interest</h2>
        <div className="flex gap-2">
          <button
            type="button"
            className="px-3 py-1 text-xs font-medium text-white bg-green-600 rounded hover:bg-green-700 transition-colors mt-2"
            // onClick={(e) => handleAddRow(e, selectedRows ? selectedRows : null)}
            onClick={(e) => handleAddRow(e)}
          >
            <span>Add +</span>
          </button>
          {selectedRows?.length === 1 && (
    <button
      type="button"
      className="px-3 py-1 text-xs font-medium text-white bg-blue-600 rounded hover:bg-blue-700 transition-colors mt-2"
      onClick={(e) => handleAddRow(e, selectedRows)}  // inserts above
    >
      <span>Insert Above ↑</span>
    </button>
  )}
          {/* <button
            className={`p-2 ${selectedRows?.length === 0 ? "invisible" : ""}`}
            onClick={(e)=>handleDeleteSelected(e)}
          >
            <img src={deleteIcon} alt="delete-icon" className="w-4 h-4" />
          </button> */}
        </div>
      </div>
      <div ref={containerRef} className="overflow-x-auto min-h-[220px]">
        {selectedRows?.length > 0 && (
          <button
            onClick={() => deleteSelectedRows(selectedRows)}
            disabled={selectedRows?.length === 0}
            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 mb-2"
          >
            Delete Selected
          </button>
        )}
        {selectedRows?.length > 0 && (
          <button
            onClick={() => markFOCForSelectedRows(selectedRows)}
            disabled={selectedRows?.length === 0}
            className="ms-2 px-3 py-1 bg-gray-500 text-white rounded hover:bg-gray-800 mb-2"
          >
            Mark As FOC
          </button>
        )}
        {selectedRows?.length > 0 && (
          <button
            onClick={() => markSubstituteForSelectedRows(selectedRows)}
            disabled={selectedRows?.length === 0}
            className="ms-2 px-3 py-1 bg-gray-500 text-white rounded hover:bg-gray-800 mb-2"
          >
            Mark As Substitute
          </button>
        )}
        
        <table className="min-w-full bg-white border border-gray-300   ">
          <thead className="">
            <tr className="bg-gray-200  rounded">
              <th className="border px-2 py-1 text-center">
                <input
                  className="rounded border border-sm shadow"
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={
                    selectedRows?.length === productsInQuotationState?.length &&
                    productsInQuotationState?.length > 0
                  }
                />
              </th>

              <th className="px-1 py-0.5 font-normal border">Cust Ref</th>
              <th className="px-1 py-0.5 font-normal border">Item Code</th>
              <th className="px-1 py-0.5 font-normal w-[300px]  border">
                Description
              </th>
              <th className="px-1 py-0.5 font-normal border">Image</th>
              <th className="px-1 py-0.5 font-normal border">Unit</th>
              {/* <th className="px-1 py-0.5 font-normal border">Curr Stock</th> */}
              <th className="px-1 py-0.5 font-normal border">Qty</th>
              <th className="px-1 py-0.5 font-normal border">Price</th>
              <th className="px-1 py-0.5 font-normal border">Amnt</th>
              {url != "/sales_order_details_user" && (
                <>
                {/* sample qty user can enter sample qty less than equal to qty confirmed with sir approving person can decide how much to give */}
                  <th className="px-1 py-0.5 font-normal border">Sample Qty</th>
                  <th className="px-1 py-0.5 font-normal border">Status</th>
                </>
              )}
            </tr>
          </thead>

          <tbody>
          {console.log('productEntries In Quotation Table--',productsInQuotationState)}
            {productsInQuotationState?.map((row, index) => (
              <tr key={row.id} className="text-sm">
                
                <td className=" border w-[20px]  text-center">
                  <input
                    type="checkbox"
                    className="rounded border border-sm shadow"
                    checked={selectedRows.includes(index)}
                    onChange={() => toggleRowSelection(index)}
                  />
                </td>

                <td className=" border w-[70px] text-center">
                  <input
                    type="text"
                    value={row.itemCustRef}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemCustRef", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td>

                <td className=" border relative w-[150px]">
                  

                  <Autocomplete
                    ListboxProps={{
                      onKeyDown: (e) => {
                        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                          e.stopPropagation();
                        }
                      },
                    }}
                    // 1. Data Source
                    options={productData || []}
                    ListboxComponent={TableListboxComponent} // Use the custom table container
                    sx={{
                      // Style for keyboard navigation (arrow keys)
                      "& .MuiAutocomplete-option.Mui-focused": {
                        backgroundColor: "#3b82f6 !important",
                        color: "white !important",
                        "& p, & span": {
                          color: "white !important",
                        },
                      },
                      // Style for selected item
                      '& .MuiAutocomplete-option[aria-selected="true"]': {
                        backgroundColor: "#2563eb !important", // darker blue
                        color: "white !important",
                        "& p, & span": {
                          color: "white !important",
                        },
                      },
                      // Hover style
                      "& .MuiAutocomplete-option:hover": {
                        backgroundColor: "#60a5fa !important",
                        color: "white !important",
                        "& p, & span": {
                          color: "white !important",
                        },
                      },
                    }}
                    // 2. Display logic (what shows in the list and the input)
                    getOptionLabel={(option) => option.Code || ""}
                    // 3. Selection logic
                    // value={productData?.find((p) => p.Code === (row.Prod_code || row.itemCode)) || null}

                    value={
                      // 1. Try to find the full object in the loaded product list
                      productData?.find(
                        (p) => p.Code === (row.Prod_code || row.itemCode)
                      ) ||
                      // 2. If not found (or data not loaded yet), create a temporary object using the code we have
                      (row.Prod_code || row.itemCode
                        ? { Code: row.Prod_code || row.itemCode }
                        : null)
                    }
                    onInputChange={(event, newInputValue, reason) => {
                      // 'input' reason means the user is actually typing
                      if (reason === "input") {
                        console.log("Searching for:", newInputValue);

                        // Call your API function here
                        // fetchProductData(newInputValue);

                        // If you are using your existing handleInputChange to trigger logic:
                        handleInputChange(
                          row.id,
                          row.Prod_code ? "Prod_code" : "itemCode",
                          newInputValue
                        );
                      }
                      setHighlightedIndex(-1);
                    }}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        selectProduct(newValue.Code);
                        
                        // focus goes to qty
                        setPendingQtyFocus(row.id); // 
                      }else{
                        
                        handleInputChange(
                          row.id,
                          row.Prod_code ? "Prod_code" : "itemCode",
                          newValue
                        );
                      }
                      setHighlightedIndex(-1);
                    }}
                    // 4. Filtering logic (mimicking your existing filter)
                    filterOptions={(options, state) =>
                      options.filter(
                        (option) =>
                          option.Code?.toLowerCase().includes(
                            state.inputValue.toLowerCase()
                          ) ||
                          option.Description?.toLowerCase().includes(
                            state.inputValue.toLowerCase()
                          )
                      )
                    }
                    // 5. Custom Dropdown Item Rendering (Matching your current UI)
                    renderOption={(props, option, state) => {
                      // 1. Destructure the internal key out of props.
                      // MUI needs this specific key to track keyboard focus correctly.
                      const { key, ...otherProps } = props;
                      const isHighlighted = state.index === highlightedIndex;
                      return (
                        <tr
                          {...props}
                          key={option.Code}
                          className={`border-b border-gray-50 cursor-pointer transition-colors ${
                            isHighlighted
                              ? "bg-blue-100 ring-2 ring-blue-400"
                              : "hover:bg-blue-50"
                          }`}
                          data-option-index={state.index}
                        >
                          <td className="p-2">
                            <div className=" text-gray-700">{option.Code}</div>
                          </td>
                          <td className="p-2">
                            <div className=" text-gray-700 truncate w-full">
                              {option.Description}
                            </div>
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.Unit}
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.Category}
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.Ttl_Stk}
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.Br_Stk}
                          </td>
                          <td className="p-2 text-center text-xs text-gray-600">
                            {option.Group}
                          </td>
                          <td className="p-2 text-center text-xs text-gray-600">
                            {option.Sgroup}
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.SelPrice}
                          </td>
                        </tr>
                      );
                    }}
                    // 6. The Input Field
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Enter Item Code"
                        // ⭐️ REFS FOR FOCUS JUMPING
                        inputRef={(el) => (rowInputRefs.current[row.id] = el)}
                        onKeyDown={(e) => {
                          const optionsLength = productData?.length || 0;

                          // Handle Arrow Down - Navigate through dropdown
                          if (e.key === "ArrowDown") {
                            e.preventDefault();
                            e.stopPropagation();

                            e.nativeEvent.stopImmediatePropagation();

                            setHighlightedIndex((prev) => {
                              // If no selection, start at first item
                              if (prev === -1) return 0;
                              // Move to next item, wrap to first if at end
                              const next = prev + 1;
                              return next >= optionsLength ? 0 : next;
                            });
                          }

                          // Handle Arrow Up - Navigate backwards through dropdown
                          else if (e.key === "ArrowUp") {
                            e.preventDefault();
                            e.stopPropagation();

                            setHighlightedIndex((prev) => {
                              // If no selection, start at last item
                              if (prev === -1) return optionsLength - 1;
                              // Move to previous item, wrap to last if at beginning
                              const next = prev - 1;
                              return next < 0 ? optionsLength - 1 : next;
                            });
                          }

                          if (e.key === "Enter") {
                            // Check if the Autocomplete has a value before jumping
                            // const currentVal = row.Prod_code || row.itemCode;
                            // if (currentVal) {
                            //   e.preventDefault();
                            //   qtyInputRefs.current[row.id]?.focus();
                            // }

                            if (
                              highlightedIndex >= 0 &&
                              productData?.[highlightedIndex]
                            ) {
                              selectProduct(productData[highlightedIndex].Code);
                              setHighlightedIndex(-1);
                              setPendingQtyFocus(row.id); 
                            } else {
                              // No highlight - move focus to Quantity input
                              if (qtyInputRefs.current[row.id]) {
                                qtyInputRefs.current[row.id].focus();
                                qtyInputRefs.current[row.id].select();
                              }
                            }
                          }
                        }}
                        variant="standard"
                        onFocus={(e) => setCurrentF2ItemForSearchPopup(row)}
                        InputProps={{
                          ...params.InputProps,
                          disableUnderline: true,
                          className: `px-2 py-1 text-sm ${
                            row.itemCode?.length > 0 &&
                            !row.isSelectedItemCodeCorrect
                              ? "bg-red-200"
                              : "bg-transparent"
                          }`,
                        }}
                      />
                    )}
                    freeSolo={true}
                    onFocus={() => {
                      setCurrentF2ItemForSearchPopup(row);
                      setHighlightedIndex(-1);
                    }}
                    // 7. Styling for the dropdown width
                    slotProps={{
                      paper: {
                        sx: {
                          width: containerRef.current
                            ? `calc(${containerRef.current.offsetWidth}px - 200px)`
                            : "auto", // Your desired width
                          marginTop: "4px", // Slight gap from input
                          boxShadow: 3,
                          // Ensure it doesn't shift left/right incorrectly
                          marginLeft: 0,
                        },
                      },
                      popper: {
                        // This ensures the popper stays glued to the left edge of the input
                        placement: "bottom-start",
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, 4], // [Skidding, Distance] - keeps it aligned to the left edge
                            },
                          },
                        ],
                      },
                    }}
                  />
                </td>

                <Tooltip
                  title={row.Prod_Description || row.itemDescription}
                  arrow
                >
                  <td className=" border ">
                    <textarea
                      style={{ height: "35px" }}
                      onFocus={(e) => {
                        e.target.style.height = "auto";
                        e.target.style.height = calcHeight(e) + "px";
                        e.target.selectionStart = e.target.value.length;
                        moveCaretToEnd(e.target);
                        // Work around Chrome's little problem
                        window.setTimeout(function () {
                          moveCaretToEnd(e.target);
                        }, 1);
                      }}
                      onInput={(e) => {
                        e.target.style.height = "auto";
                        e.target.style.height = calcHeight(e) + "px";
                      }}
                      class="w-full"
                      value={row.Prod_Description || row.itemDescription}
                      onChange={(e) =>
                        handleInputChange(
                          row.Prod_Description || row.id,
                          row.Prod_Description
                            ? "Prod_Description"
                            : "itemDescription",
                          e.target.value
                        )
                      }
                    ></textarea>
                  </td>
                </Tooltip>

                {/* <td className=" border w-[70px] text-center">
                  <input
                    type="text"
                    value={row.itemImage}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemImage", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td> */}

                <td className="border w-[70px] text-center p-1">
                  <div className="flex justify-center items-center h-full">
                    <img
                      // onError={(e) => {
                      //   e.target.style.display = "none"; //replacement image imported above
                      // }}
                      src={fetchItemImage(row.prod_imagepath || row.itemImage)}
                      alt="Product"
                      className="w-6 h-6 object-cover rounded-md mx-auto"
                    />
                  </div>
                </td>

                <td className=" border w-[70px] text-center">
                  <input
                    type="text"
                    value={row.Prod_Unit || row.itemUnit}
                    onChange={(e) =>
                      handleInputChange(
                        row.Prod_code || row.id,
                        row.Prod_code ? "Prod_Unit" : "itemUnit",
                        e.target.value
                      )
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td>

                {/* <td className=" border w-[80px] text-center">
                  <input
                    type="text"
                    value={row.itemCurrentStock}
                    onChange={(e) =>
                      handleInputChange(
                        row.id,
                        "itemCurrentStock",
                        e.target.value
                      )
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td> */}
                <td className=" border w-[40px]">
                  <input
                    min={"0"}
                    
                    ref={(el) => {
                      qtyInputRefs.current[row.id] = el;            
                      if (qtyInputRefsFromParent)                   
                        qtyInputRefsFromParent.current[row.id] = el;
                    }}
                    type="number"
                    value={row.Prod_Qty || row.itemQuantity}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      handleInputChange(
                        row.Prod_code || row.id,
                        row.Prod_code ? "Prod_Qty" : "itemQuantity",
                        e.target.value
                      )
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Stop form submission
                        // Jump to the Price field of the SAME row
                        if (priceInputRefs.current[row.id]) {
                          priceInputRefs.current[row.id].focus();
                          priceInputRefs.current[row.id].select();
                        }
                      }
                    }}
                  />
                </td>
                <td className=" border w-[40px]">
                  {row.itemFoc === "FOC" ? (
                    <p
                      style={{
                        display: "inline-flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <span>FOC</span>
                    </p>
                  ) : (
                    <input
                      min={"0"}
                      type="number"
                      ref={(el) => (priceInputRefs.current[row.id] = el)}
                      value={row.Prod_Price || row.itemPrice}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) =>
                        handleInputChange(
                          row.Prod_code || row.id,
                          row.Prod_code ? "Prod_Price" : "itemPrice",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent default form behavior

                          // 1. Call the function to add a new row
                          handleAddRow(e);

                          // Note: The focus jump to the NEW row's Autocomplete
                          // is likely already handled by a useEffect in your
                          // allEntriesForm.js that watches the productEntries length.
                        }
                      }}
                    />
                  )}
                </td>
                <td className=" border w-[30px] text-center">
                  {row.itemFoc === "FOC" ? (
                    <p
                      style={{
                        display: "inline-flex",
                        justifyContent: "center",
                        width: "100%",
                      }}
                    >
                      <span>0</span>
                    </p>
                  ) : (
                    <input
                      type="number"
                      value={
                        row.itemCustRef === "OPT" || row.itemCustRef === "OPTION"
                          ? ""
                          : row.Lead_ID
                          ? row.Prod_Qty * row.Prod_Price
                          : row.itemQuantity * row.itemPrice
                      }
                      readOnly
                      className="w-full p-0 border-none cursor-not-allowed focus:outline-none focus:ring-0 text-center"
                    />
                  )}
                </td>

                {url != "/sales_order_details_user" && (
                  <>
                    <td className=" border w-[70px] text-center">
                    <input
    type="number" // Changed to number for cleaner validation
    disabled={
      row.Have_Sample?.toUpperCase()?.trim() === "APPROVED"
        ? true
        : false
    }
    value={row.sample_quantity_requested || ""}
    onWheel={(e) => e.target.blur()}
    onChange={(e) => {
      // 1. Remove anything that isn't a digit (strips out hyphens, letters, etc.)
      const cleanValue = e.target.value.replace(/\D/g, "");

      // 2. Convert to integers for comparison (fallback to 0 if empty)
      const enteredSampleQty = parseInt(cleanValue, 10) || 0;
      const maxAllowedQty = parseInt(row.Prod_Qty || row.itemQuantity, 10) || 0;

      // 3. Enforce boundaries
      if (cleanValue === "") {
        // Allow the user to backspace and leave it empty
        handleInputChange(row.id, "sample_quantity_requested", "");
      } else if (enteredSampleQty > maxAllowedQty) {
        // Cap it to the maximum allowed quantity
        handleInputChange(row.id, "sample_quantity_requested", maxAllowedQty.toString());
      } else {
        // Save the cleaned-up digit string
        handleInputChange(row.id, "sample_quantity_requested", cleanValue);
      }
    }}
    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
  />
                    </td>

                    <td className=" border w-[70px] text-center">
                      <p>{row.Have_Sample}</p>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        <div className="text-right gap-2">
          <button
            type="button"
            className="px-3 py-1 text-xs font-medium text-white bg-green-600 rounded hover:bg-green-700 transition-colors mt-2"
            onClick={(e) => handleAddRow(e)}
          >
            <span>Add +</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductsInQuotation;
